export default{
    cadastra:{
        method:'post',
        url:'saude/trabalhor/cadastro'
    },
    delete:{
        method:'delete',
        url:'saude/trabalhor/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'saude/trabalhor/lista'
    },
    editar:{
        method:'get',
        url:'saude/trabalhor/editar{/id}'
    },
    update:{
        method:'post',
        url:'saude/trabalhor/update'
    },
    evento:{
        method:'get',
        url:'acidentetrabalhor/evento/2210{/id}'
    },
    eventolista:{
        method:'get',
        url:'acidentetrabalhor/evento/2210/lista{/id}'
    },
    eventocadastra:{
        method:'post',
        url:'saude/trabalhor/evento2220/cadastro'
    },
    eventoupdate:{
        method:'post',
        url:'saude/trabalhor/evento2220/update'
    },
    eventodelete:{
        method:'delete',
        url:'saude/trabalhor/evento2220/deletar{/id}'
    },
}